import { jsx as s } from "react/jsx-runtime";
import { createContext as h, useState as L, useCallback as m, useEffect as f } from "react";
import { defaultNS as r } from "./index23.mjs";
const x = () => {
  const t = h(null);
  return { LocaleContext: t, LocaleProvider: ({
    i18n: e,
    languageCode: l,
    loadLangBundle: o,
    onChange: n,
    children: d
  }) => {
    const [c, i] = L(
      e.language
    ), u = m(
      (a) => {
        e.hasResourceBundle(a, r) ? (e.changeLanguage(a), i(a), n == null || n(a)) : o == null || o(a, r).then((g) => {
          e.addResourceBundle(a, r, {
            ...g
          }), e.changeLanguage(a), i(a), n == null || n(a);
        }).catch((g) => {
          console.error("Error loading lang bundle", a, g);
        });
      },
      [e, o, n]
    );
    return f(() => {
      e.isInitialized && e.language !== l && u(l);
    }, [l, u, e.isInitialized, e.language]), /* @__PURE__ */ s(t.Provider, { value: { i18n: e, currentLanguageCode: c, changeLocale: u }, children: d });
  } };
};
export {
  x as createLocaleProvider
};
